import { EventBus, router, store } from "@/internal";
import "@/plugins/axios";
import { i18n } from "@/plugins/i18n";
import "@/plugins/vee-validate";
import "@babel/polyfill";
import "@fortawesome/fontawesome-pro/css/all.css";
import { DatePicker } from "element-ui";
// @ts-ignore
import locale from "element-ui/lib/locale";
// @ts-ignore
import lang from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/reset.css";
import { HelixModals, Injector } from "helix-vue-components";
import "helix-vue-components/lib/helix-vue-components.css";
import IdleVue from "idle-vue";
import Vue from "vue";
import App from "./App.component";
import { currencyFilter } from "./filters/currency.filter";
import { dateFilter } from "./filters/date.filter";
import { Http } from "./namespaces/Http";
import "./plugins/vuetify";
import "./registerServiceWorker";

Vue.config.productionTip = false;

const api = new Http.ApiJwtService();

locale.use(lang);
Vue.use(DatePicker);
Vue.use(Injector);
Vue.use(IdleVue, {
  eventEmitter: EventBus,
  store,
  startAtIdle: false,
  idleTime: process.env.VUE_APP_SESSION_TIMEOUT
});
Vue.use(HelixModals, { i18n, store, router });
Vue.filter("currency", currencyFilter);
Vue.filter("date", dateFilter);
const setToken = async () => {
  store.dispatch("authModule/setAccessToken");
  if (store.getters["authModule/accessToken"]) {
    await store.dispatch("authModule/getByToken");
  }
};
setToken().finally(() => {
  const loader = document.getElementById("loader");
  document.body.removeChild(loader!);
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
});
